import { Button } from '@pets-ui/Button/Button'
import { HStack } from '@pets-ui/HStack/HStack'
import { ArrowLeftSmall } from '@pets-ui/icons'
import { Input } from '@pets-ui/Input/Input'
import { isEmail } from '@utils'
import Cookies from 'js-cookie'
import queryString from 'query-string'
import { useEffect, useState, type Dispatch, type SetStateAction } from 'react'
import { useTranslation } from 'react-i18next'
import { useRequestAccountBindingStatus } from '../../../hooks/apis/wp/useRequestAccountBindingStatus'
import { wordPressNavigate } from '../../../utils/wordPressRoute'
import { CardTitleWithIcon } from '../login/CardTitleWithIcon'
import { BindStep } from '../login/types'
import { useContextMyAccountDialog } from './Provider/useContextMyAccountDialog'

interface BindPhoneProps {
  email: string
  setEmail: Dispatch<SetStateAction<string>>
  setStep: (step: BindStep) => void
}

export function BindEmail(props: BindPhoneProps) {
  const { t } = useTranslation()
  const { setStep, email, setEmail } = props
  const [emailError, setEmailError] = useState('')
  const { trigger, isMutating } = useRequestAccountBindingStatus()
  const { showDialogServerError } = useContextMyAccountDialog()

  const handleClickConfirm = async () => {
    if (!email) return

    if (!isEmail(email)) {
      setEmailError(String(t('error.incorrectEmailFormat')))
      return
    }
    try {
      const { data } = await trigger({ account: email, type: 'email' })
      if (data.data.isBound) {
        setEmailError(String(t('login.emailIsAlreadyBound')))
        return
      }
      setEmailError('')
      Cookies.set('account', email)
      setStep(BindStep.VALIDATE)
    }
    catch (e) {
      console.error(e)
      showDialogServerError()
    }
  }
  const search = queryString.parse(window.location.search)
  useEffect(() => {
    if (search?.otpCode) setStep(BindStep.VALIDATE)
  }, [search?.otpCode, setStep])

  return (
    <>
      <CardTitleWithIcon
        title={t('login.verifyIdentity')}
        leftIcon={<ArrowLeftSmall />}
        onClickLeft={() => { wordPressNavigate('/my-account/edit-account/') }}
      />
      <HStack gap={5}>
        <Input
          label={t('login.email')}
          placeholder={String(t('login.pleaseEnter'))}
          fullWidth
          value={email}
          onChange={e => setEmail(e.target.value)}
          error={!!emailError}
          helpText={emailError}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              handleClickConfirm()
            }
          }}
        />
        <Button
          loading={isMutating}
          fullWidth
          onClick={handleClickConfirm}
          disabled={email?.trim() === ''}
        >
          {t('button.confirm')}
        </Button>
      </HStack>
    </>
  )
}
